<table class="table table-bordered">
    <tbody>
        @for (module of task_management_access_modules; track $index) {
        <tr>
            <td [attr.rowspan]="module.access.length+1">
                {{module.module}}
            </td>
        </tr>
        @for (access of module.access; track $index) {
        <tr>
            <td>
                <mat-checkbox color="primary" [(ngModel)]="access.value" [ngModelOptions]="{standalone: true}">
                    {{access.name}}
                </mat-checkbox>
            </td>
        </tr>
        }
        }
    </tbody>
</table>